import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";
import Connector from "@helpers/Connector";

interface PropsInterface {
  callback: any;
  data: any;
}

interface StateInterface {}

export default Connector(
  class Default extends React.Component<PropsInterface, StateInterface> {
    public render() {
      return (
        <div className="modal modal--event-cancel">
          <form>
            <div className="modal__header">
              <div className="modal__title">Регистрация закрыта!</div>
              <button
                className="modal__close"
                onClick={() => {
                  Middleware.Ui.Modal.closeAll();
                }}
              />
            </div>
            <div className="modal__body">
              <div className="modal__desc">
                Онлайн-выставка завершилась. Ваш личный кабинет и кабинет вашей
                компании в нетворкинге будет доступен на следующих проектах
                Profi.Travel.
              </div>
            </div>
            <div className="modal__footer">
              <Link
                className="btn btn--red"
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  Middleware.Ui.Modal.closeAll();
                }}
              >
                До встречи!
              </Link>
            </div>
          </form>
        </div>
      );
    }
  }
);
